import(/* webpackMode: "eager" */ "/vercel/path0/app/auth/magic-link/page.tsx");
